import { BSWDesignSystemError } from '../../../utils/DesignSystemError';

export class CardInputValidationError extends BSWDesignSystemError {
  constructor(message: string) {
    super(message);
    this.name = 'CardInputValidationError';
  }
}
